<template lang="pug">
.events
  .container
    h1 前沿活动
    .news-wapper
      article.news-item(v-for="item in activities" :key="item.id")
        .banner(:style="{backgroundImage: 'url(' + item.avatar_url + '?imageView2/1/w/1069/h/620/interlace/1/q/88/interlace/1/)'}")
          .activity-type
            .en
              | FRONTIER
              br
              | {{item.activity_type}}
            .cn {{item.activity_type | getCN}}
        .content
          .activity-content
            h4 {{item.title}}
          .activity-meta
            a.link(v-if="item.article_link" :href="item.article_link" target="_blank") 查看
            .time {{item.activity_time | formatTime}}
    .more
      a(href="/news") 更多活动 >
</template>

<script>
import api from '../store/api'
const CNNAME = {workshop: '前沿工作坊', camp: '超频之旅', study: '近场研究'}

export default {
  name: 'vcontent',
  data () {
    return {
      activities: []
    }
  },
  mounted () {
    this.getActivity()
  },methods: {
    getActivity () {
      api.get(`admin/activities?per=3`).then((result) => {
        this.activities = result.data.activities.sort(function(a, b) {
          return new Date(b.activity_time) - new Date(a.activity_time)
        })
      }).catch((err) => {
        console.log(err.toString())
      })
    }
  },
  filters: {
    formatTime (val) {
      let date = new Date(val)
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    getCN (val) {
      return CNNAME[val]
    }
  }
}
</script>

<style lang="stylus">
@import '../assets/css/var'

.events
  background #eee
  color #000
  h1
    font-family 'FZLTTHCJW--GB1-0'
    font-size 50px
    padding 1em 0
  .news-wapper
    position relative
    margin 0 auto
    display flex
    justify-content space-between
    flex-shrink 0
    .news-item
      // position absolute
      display inline-block
      width 30%
      line-height 1.5em
      .banner
        background url(../assets/imgs/x.jpg) no-repeat center top
        background-size cover
        position relative
        padding-bottom 54%
        color #fff
        .activity-type
          background #000
          display inline-block
          padding .5em
          .en, .cn
            display inline-block
            vertical-align middle
          .en
            margin-right .4em
            font-family 'BebasNeue'
            line-height .9
            text-align right
          .cn
            font-family 'FZLTTHCJW--GB1-0'
            font-size 1.2em
      .content
        padding 15px 20px
        .activity-content
          h4
            font-size 15px
            font-weight 900
            line-height 1.2
            margin-bottom .3em
            height 36px
          p
            font-size 14px
            color #999
        .activity-meta
          margin-top 20px
          border-top 1px solid #000
          padding-top .5em
          .time
            font-size 14px
          .link
            color #000
            float right
  .more
    text-align right
    padding-top 50px
    padding-bottom 50px
    a
      color #5EC5FF
  @media $media
    .news-wapper
      flex-direction column
      .news-item
        width 100%
        margin-bottom 20px
        .content
          .activity-content
            h4
              height auto
    .more
      padding-top 30px
</style>



// WEBPACK FOOTER //
// Events.vue?1886575d